import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { updateProcedureCategory } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function updateCategory({
  accountId,
  procedureCategoryId,
  procedureIds,
}: TVariables): Promise<TResult> {
  const response = await fetch(updateProcedureCategory(accountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ procedureCategoryId, procedureIds }),
  });
  return response.json();
}

export type TError = ErrorModal;

export type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

export type TVariables = {
  accountId: number;
  procedureCategoryId: number;
  procedureIds: Array<number> | null;
};

export type TSnapshot = unknown;

function useUpdateProcedureCategory(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ accountId, procedureCategoryId, procedureIds }: TVariables) => {
      const updatedCategory = await updateCategory({
        accountId,
        procedureCategoryId,
        procedureIds,
      });

      if (updatedCategory.Data) {
        queryClient.invalidateQueries(
          ['get_procedure_builder_procedures', accountId],
          {
            refetchInactive: true,
          },
        );
        queryClient.invalidateQueries(['get_procedure'], {
          refetchInactive: true,
        });
      } else if (updatedCategory.Errors) throw updatedCategory;
      return updatedCategory;
    },
  );
}

export { useUpdateProcedureCategory };
